export enum DataTypes {
  MONETARY = "MONETARY",
  STRING = "STRING",
  DATE = "DATE",
  DECIMAL = "DECIMAL",
  SHARES = "SHARES",
  PERShARE = "PERShARE",
  PURE = "PURE",
}

export enum PeriodTypes {
  DURATION = "DURATION",
  INSTANT = "INSTANT",
}

export enum UnitTypes {
  KRW = "KRW",
  USD = "USD",
  JPY = "JPY",
}

export enum BalanceTypes {
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
}

export enum AccountingPeriod {
  /**
   * 기초/기말
   * @author 이상민
   */
  BEGIN = "BEGIN",
  END = "END",
  NONE = "NONE",
}

export enum TargetYear {
  /**
   * 당기/전기
   * @author 이상민
   */
  CURRENT = "CURRENT",
  PRIOR = "PRIOR",
}

export enum Accumulated {
  /**
   * 누적/비누적
   * @author 이상민
   */
  ACC = "ACC",
  QUARTER_ACC = "QUARTER_ACC",
}
